<template>
    <div class="resources-content">
        <el-tabs v-model="materialTabs" type="card" class="resources-content" @tab-click="updateData">
            <el-tab-pane name="subject">
                <span slot="label" class="tab-txt">
                    <i class="iconfont">&#xe782;</i>试题管理
                </span>
                <MaterialExamSubject ref="examRef"></MaterialExamSubject>
            </el-tab-pane>
            <el-tab-pane name="testPaper">
                <span slot="label" class="tab-txt">
                    <i class="iconfont">&#xe788;</i>试卷管理
                </span>
                <MaterialExamPapers ref="paperRef"></MaterialExamPapers>
            </el-tab-pane>
            <el-tab-pane name="tags">
                <span slot="label" class="tab-txt">
                    <i class="iconfont">&#xe789;</i>标签管理
                </span>
                <MaterialExamTags ref="tagsRef"></MaterialExamTags>
            </el-tab-pane>
            <el-tab-pane name="topicCategory" v-if="role === 3">
                <span slot="label" class="tab-txt">
                    <i class="el-icon-s-grid" style="font-size: 14px;"></i> 试题分类
                </span>
                <class-manage-exam ref="examClassRef"></class-manage-exam>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import MaterialExamTags from 'components/material/MaterialExamTags';
    import MaterialExamSubject from 'components/material/MaterialExamSubject';
    import MaterialExamPapers from 'components/material/MaterialExamPapers';
    import ClassManageExam from "@/components/classManage/ClassManageExam.vue";

    export default {
        name: "MaterialExam",
        data() {
            return {
                materialTabs: 'subject',
                role: Number(localStorage.getItem('role')),
            }
        },
		created() {
			// mtype: 1: 试题管理 2: 试卷管理  3: 标签管理
			if (this.$route.query.mtype && this.$route.query.mtype == 2) {
				this.materialTabs = 'testPaper';
			}
            
            if (this.$route.params.type && this.$route.params.type === "paper") {
                this.materialTabs = "testPaper";
            }
		},
        components: {
            MaterialExamTags,
            MaterialExamSubject,
            MaterialExamPapers,
            ClassManageExam
        },
        methods: {
            updateData() {
                this.$refs.examRef.initData();
                this.$refs.paperRef.setInit();
                this.$refs.tagsRef.getTagsList();
                this.$refs.tagsRef.getClassList();
                if (this.role === 3) {
                    this.$refs.examClassRef.list();
                }
                
            },
        }
    }
</script>

<style scoped>

</style>
